function TemplateSvc($q, $http, $templateCache) {
    'ngInject';

    return {
        get(path) {
            const deferred = $q.defer();
            const cacheTemplate = $templateCache.get(path);

            if (cacheTemplate) {
                deferred.resolve(angular.element(cacheTemplate));
            } else {
                $http({
                    method: 'GET',
                    url: path
                }).success((Template, status) => {
                    $templateCache.put(path, Template);
                    return deferred.resolve(angular.element(Template));
                }).error((data, status) => deferred.reject(data));
            }
            return deferred.promise;
        }
    };
}

// Service for loading templates and partials. return rasterized dom elements
angular
    .module('BB')
    .service('TemplateSvc', TemplateSvc);




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/template_svc.service.js